import { Box } from "@chakra-ui/react";
import Field from "ui/components/Input/Field";
import InputTablePermissoes from "ui/components/Input/InputTablePermissoes";
import { showError } from "infra/helpers/alerta";
import CollapseSwitch from "components/CollapseSwitch";

function FormPermissao({
  tenantId,
  control,
  watch,
  setField,
  permissoesName = "permissoes",
  emailField = "email",
}: {
  tenantId: string;
  control: any;
  watch: any;
  setField: any;
  permissoesName?: string;
  emailField?: string;
}) {
  const limitarAcessoModulo = watch("limitarAcessoModulo");

  return (
    <>
      <CollapseSwitch
        onChange={(v) => {
          if (!v && !watch(emailField)) {
            showError(
              "Para habilitar permissões a pessoa precisa ter um email vinculado!"
            );

            return;
          }

          setField("limitarAcessoModulo", v);
        }}
        open={!!limitarAcessoModulo}
        title="Limitar acesso aos módulos"
      >
        {limitarAcessoModulo ? (
          <Box mt="16px">
            <Field
              shouldUnregister
              control={control}
              name={permissoesName}
              render={({ field }) => (
                <InputTablePermissoes
                  origem="app"
                  tenantId={tenantId}
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </Box>
        ) : null}
      </CollapseSwitch>
    </>
  );
}

export default FormPermissao;
